/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/10/triangle-down': {
    width: 7,
    height: 4,
    viewBox: '0 0 7 4',
    data: '<path pid="0" _fill="#272c33" fill-rule="nonzero" d="M3.5 4L7 0H0z"/>'
  }
})
